/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Entrée de référentiel (nature de rémunération, type de support...).
 * @export
 * @interface ReferentialItemDto
 */
export interface ReferentialItemDto {
    /**
     * 
     * @type {string}
     * @memberof ReferentialItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferentialItemDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferentialItemDto
     */
    libelle?: string | null;
}

/**
 * Check if a given object implements the ReferentialItemDto interface.
 */
export function instanceOfReferentialItemDto(value: object): value is ReferentialItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ReferentialItemDtoFromJSON(json: any): ReferentialItemDto {
    return ReferentialItemDtoFromJSONTyped(json, false);
}

export function ReferentialItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
    };
}

export function ReferentialItemDtoToJSON(json: any): ReferentialItemDto {
    return ReferentialItemDtoToJSONTyped(json, false);
}

export function ReferentialItemDtoToJSONTyped(value?: ReferentialItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'libelle': value['libelle'],
    };
}

